import React, { useEffect } from "react";
import { useField } from "formik";
import Switch from "react-switch";

interface OnOffSwitchProps {
  name: string;
  handleChange?: (value: boolean) => void;
  disabled?: boolean;
}

const OnOffSwitch: React.FC<OnOffSwitchProps> = ({
  name,
  handleChange,
  disabled,
}) => {
  const [field, , helper] = useField(name);

  useEffect(() => {
    if (handleChange) {
      handleChange(field.value);
    }
  }, [field.value, handleChange]);

  const onChange = (value: boolean): void => {
    helper.setValue(value);
  };

  return (
    <label>
      <Switch checked={field.value} onChange={onChange} disabled={disabled} />
    </label>
  );
};

export default OnOffSwitch;